import { CardContent, Grid } from "@mui/material";
import Logo from "../../../assets/images/logo_medium.png";
import Activate from "../../commons/setPassword/setPassword";
import { StyledActivateAccountContainer } from "../../styled/accident";
import LoginFooter from "../login/loginFooter";

function ActivateAccount() {
  return (
    <StyledActivateAccountContainer.GridContainer container justify="center">
      <StyledActivateAccountContainer.LoginContainer item xs={4}>
        <StyledActivateAccountContainer.LoginCard>
          <CardContent>
            <Grid
              container
              justify="center"
              alignItems="center"
              direction="column">
              <StyledActivateAccountContainer.LogoImage src={Logo} alt="Logo" />
            </Grid>
            <StyledActivateAccountContainer.Text>
              Confirmación de cuenta
            </StyledActivateAccountContainer.Text>
            <Activate type="ActivateAccount" />
          </CardContent>
          <LoginFooter loginAccount />
        </StyledActivateAccountContainer.LoginCard>
      </StyledActivateAccountContainer.LoginContainer>
    </StyledActivateAccountContainer.GridContainer>
  );
}

export default ActivateAccount;
